import { render, staticRenderFns } from "./MasterGroupClassDetailsCard.vue?vue&type=template&id=54a3db46"
import script from "./MasterGroupClassDetailsCard.vue?vue&type=script&lang=js"
export * from "./MasterGroupClassDetailsCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports